import React from 'react'
import SUIInput from 'semantic-ui-react/dist/commonjs/elements/Input'
export default function Inputters (props) {
  return (
    <SUIInput {...props} />
  )
}
